import { render } from "./mobile-level-select.vue?vue&type=template&id=23152f65&scoped=true&ts=true"
import script from "./mobile-level-select.vue?vue&type=script&lang=ts"
export * from "./mobile-level-select.vue?vue&type=script&lang=ts"

import "./mobile-level-select.vue?vue&type=style&index=0&id=23152f65&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23152f65"]])

export default __exports__